import { MouseEvent } from 'react';
import { MicrobiomeAgeSample } from 'services/microbiome/types/microbiome-age.types';
import styles from './SampleDot.module.css';

// Tier colors for the current sample (filled core + halo); past samples are hollow.
const TIER_CORE: Record<string, string> = {
  green: 'var(--green-300)',
  orange: 'var(--orange-300)',
  red: 'var(--red-300)',
};
const TIER_HALO: Record<string, string> = {
  green: 'var(--green-200)',
  orange: 'var(--orange-200)',
  red: 'var(--red-200)',
};

type SampleDotProps = {
  // Injected by recharts <ReferenceDot shape={...} />
  cx?: number;
  cy?: number;
  sample: MicrobiomeAgeSample;
  onShow: (sample: MicrobiomeAgeSample, e: MouseEvent<SVGElement>) => void;
  onHide: () => void;
};

export default function SampleDot({
  cx,
  cy,
  sample,
  onShow,
  onHide,
}: SampleDotProps) {
  if (cx === undefined || cy === undefined || isNaN(cx) || isNaN(cy))
    return null;

  const core = TIER_CORE[sample.evaluationColor] ?? 'var(--cold-grey-400)';
  const halo = TIER_HALO[sample.evaluationColor] ?? 'var(--cold-grey-200)';

  return (
    <svg
      x={cx - 12}
      y={cy - 12}
      width={24}
      height={24}
      overflow='visible'
      onMouseEnter={e => onShow(sample, e)}
      onMouseLeave={onHide}
      onClick={e => onShow(sample, e)}
      className={styles.dot}
    >
      {sample.isCurrent && (
        <circle
          cx={12}
          cy={12}
          r={8}
          fill='none'
          stroke={halo}
          strokeWidth={2}
        />
      )}
      <circle
        cx={12}
        cy={12}
        r={4}
        fill={sample.isCurrent ? core : 'var(--white)'}
        stroke={sample.isCurrent ? core : 'var(--cold-grey-300)'}
        strokeWidth={2}
      />
    </svg>
  );
}
